/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'

const entity = {
  longId: {
    displayName: 'voucherCode'
  },
  totalAmount: {
    displayName: 'CashAmount',
    type: IKDataEntity.Types.Float
  },
  leftAmount: {
    displayName: 'Credit',
    type: IKDataEntity.Types.Float
  },
  createdAt: {
    type: IKDataEntity.Types.Date
  }

}
const config = {
  load: async function (filter) {
    console.log(filter, 'filter')
    if (filter[0].showAll) {
      return (await hillo.get('MemberCard.php', {
        op: 'showAllMemberCardSaleRecord'
      })).content
    } else {
      const [fromDate, toDate] = filter[0].dateFilter
      return (await hillo.get('MemberCard.php', {
        op: 'showAllMemberCardSaleRecord'
      })).content.filter(item => {
        return item.createdAt > fromDate && item.createdAt < toDate + ' 23:59:59'
      })
    }
  }
}

export async function getCouponRecord (id) {
  return (await hillo.get('MemberCard.php', {
    op: 'getOne',
    withConsumeLog: true,
    id
  })).content
}

export default IKDataEntity.ModelFactory(entity, config)
